var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"st-container",attrs:{"id":"st-container"}},[_c('SearchMultiSelect',{attrs:{"selectedOptions":_vm.selected,"sourceOptions":_vm.subjectOptions,"isCheckbox":2,"placeholder":_vm.$t('search-tab.choose-subject'),"disabled":_vm.disabled,"theme":_vm.theme},on:{"onChangeSelect":_vm.changedMultiSelection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }